export const PLACE_STORAGE_KEY = 'ada-login-city';
export const DEFAULT_PLACE_ID = 'sanfrancisco';

export const PLACES = [
  {
    id: 'chicago',
    label: 'Chicago',
    latitude: 41.8781,
    longitude: -87.6298,
    timeZone: 'America/Chicago',
  },
  {
    id: 'losangeles',
    label: 'Los Angeles',
    latitude: 34.0522,
    longitude: -118.2437,
    timeZone: 'America/Los_Angeles',
  },
  {
    id: 'newyork',
    label: 'New York',
    latitude: 40.7128,
    longitude: -74.006,
    timeZone: 'America/New_York',
  },
  {
    id: 'sanfrancisco',
    label: 'San Francisco',
    latitude: 37.7749,
    longitude: -122.4194,
    timeZone: 'America/Los_Angeles',
  },
  {
    id: 'seattle',
    label: 'Seattle',
    latitude: 47.6062,
    longitude: -122.3321,
    timeZone: 'America/Los_Angeles',
  },
];

export function placeById(id) {
  return PLACES.find((p) => p.id === id) || PLACES.find((p) => p.id === DEFAULT_PLACE_ID);
}

export function placeByLabel(label) {
  if (!label) return null;
  const needle = String(label).toLowerCase();
  return PLACES.find((p) => p.label.toLowerCase() === needle) || null;
}

export function toPlaceOverride(place) {
  return {
    city: place.label,
    country: 'United States',
    latitude: place.latitude,
    longitude: place.longitude,
    timeZone: place.timeZone,
    fetchedAt: Date.now(),
  };
}
